module.exports = __webpack_public_path__ + "static/img/zhsy-1126.eb5334e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/livebackground/zhsy-1126.jpg
// module id = DMti
// module chunks = 19